import React, { useState, useEffect, useContext } from "react"
import { PCViewContext } from "../PCViewContext"
import { FilterConditionsHandler } from "../../Utils/filter_conditions_handler"
const handler = new FilterConditionsHandler()

import SP from "./Location/SP"
import PC from "./Location/PC"

const Location = (props) => {
  // modal上でのモーダルpush/popに利用
  const [prefecture, setPrefecture] = useState(props.prefecture)
  const [cityShow, setCityShow] = useState(props.prefecture ? true : false)
  const handlePrefClick = (p) => {
    setCityShow(true)
    setPrefecture(p)
  }
  const [placeCountByCities, setPlaceCountByCities] = useState({})
  const isPC = useContext(PCViewContext)
  const states = {
    cityShow,
    setCityShow,
    placeCountByCities,
    prefecture,
    setPrefecture,
    onClick: handlePrefClick,
  }

  // prefecture切替時に再取得
  useEffect(() => {
    let mounted = true
    const code = async () => {
      setPlaceCountByCities({})
      if (mounted && prefecture != null) {
        const res = await handler.fetchPlaceCounts({
          by: "city_id",
          prefecture_id: prefecture.id,
          category_id: props.category ? props.category.id : null,
        })
        setPlaceCountByCities(res)
      }
    }
    code()
    return () => {
      mounted = false
    }
  }, [prefecture, props.category])

  // propsの更新ごとに再計算
  useEffect(() => {
    setPrefecture(props.prefecture)
    setCityShow(props.prefecture ? true : false)
  }, [props.prefecture])

  return (
    <React.Fragment>
      {isPC && <PC {...props} {...states} />}
      {!isPC && <SP {...props} {...states} />}
    </React.Fragment>
  )
}

export default Location
